"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.savePropertyRemoteReducer = void 0;
var typesafe_actions_1 = require("typesafe-actions");
var SavePropertyRemoteState_init_1 = require("@/pages/common/states/SavePropertyRemoteState.init");
var SavePropertyRemoteAction_1 = require("@/pages/common/actions/SavePropertyRemoteAction");
exports.savePropertyRemoteReducer = function (state, action) {
    if (state === void 0) { state = SavePropertyRemoteState_init_1.defaultSavePropertyRemoteState; }
    switch (action.type) {
        case typesafe_actions_1.getType(SavePropertyRemoteAction_1.default.setSavePropertyIdsRemote): {
            return (__assign(__assign({}, state), { savePropertyIdsRemote: action.payload }));
        }
        case typesafe_actions_1.getType(SavePropertyRemoteAction_1.default.setIsSavePropertyIdsRemoteChanged): {
            return (__assign(__assign({}, state), { isSavePropertyIdsRemoteChanged: action.payload }));
        }
    }
    return state;
};
